import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const Modal = (props) => {
  const classes = useStyles()

  return (
    <>
      {props.ordered ? (
        <div className={classes.BackDrop} onClick={props?.modelClosed}></div>
      ) : null}
      <div
        className={`${classes.Modal} ${props.class ? props.class : ''}`}
        style={{
          transform: props?.ordered ? 'translateY(0)' : 'translateY(-50vh)',
          opacity: props?.ordered ? '1' : '0',
          width: props?.width ? props?.width : '70%',
          left: props?.left ? props?.left : '15%',
          top: props?.top ? props?.top : '',
          backgroundColor: props?.bgcolor ? props?.bgcolor : 'white',
          border: props?.border ? props?.border : '0px solid #ccc',
          boxShadow: '1px 1px 1px #00000026',
          borderRadius: '5px',
        }}
      >
        {props?.children}
      </div>
    </>
  )
}

export default Modal

const useStyles = makeStyles({
  BackDrop: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: '100',
    left: '0',
    top: '0',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  Modal: {
    position: ' fixed',
    zIndex: '500',

    border: '1px solid #ccc',
    boxShadow: '1px 1px 1px black',

    boxSizing: 'border-box',
    transition: 'all 0.3s ease-out',
  },
})
